/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaConto
 * @restrict E
 * @description Componente che gestisce il quarto step "SCelta Conto" del dettaglio pratica
 * @param {number} id-pratica - Rappesenta l'ID univoco della pratica in lavorazione
 */
(function() {
  'use strict';
  var CreasSceltaContoCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    // Spinner
    this.spinner = this.dettPraticaSrvc.spinner;
    this.subSpinner = {
      conto: false
    };

    this.ibanAddebito = null;
    this.esitoSalvataggio = false;
    var self = this;

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
    dettPraticaSrvc.isSaveEnabled = function() {
      return !!self.dettPraticaSrvc.ibanAddebito;
    };

    dettPraticaSrvc.isPrevEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return self.dettPraticaSrvc.ibanAddebito !== null;
    };

    dettPraticaSrvc.salva = function() {
      self.spinner.pratica = true;
      
      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
        self.dettPraticaSrvc.ibanAddebito;
      
      $q
        .all({salvaPratica: dettPraticaSrvc.promiseSalvaFido('/salvaConto')})
        .then(
          function(response) {
            dettPraticaSrvc.datiPratica = response.salvaPratica.data.result;
            if (self.messaggiFctr.processaResponse(response.salvaPratica)) {
              return;
            }
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.salvaPratica);
          }
        )
        .finally(function() {
          self.spinner.pratica = false;
        });
    };

    dettPraticaSrvc.nextStep = function() {
      self.spinner.pratica = true;
      
      self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
        self.dettPraticaSrvc.ibanAddebito;
      
      $q
        .all({salvaPratica: dettPraticaSrvc.promiseSalvaFido('/salvaConto')})
        .then(function(res) {
          if (res.salvaPratica.data.result) {
            $q
              .all({
                nextStep: dettPraticaSrvc.promiseCambiaStep('/passaDocumenti')
              })
              .then(
                function(response) {
                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
                    return;
                  }
                  
                  dettPraticaSrvc.datiPratica = response.nextStep.data.result;
                  dettPraticaSrvc.generaTabs();
                },
                function(reason) {
                  self.messaggiFctr.processaResponse(reason.nextStep);
                }
              )
              .finally(function() {
                self.spinner.pratica = false;
              });
          } else {
            self.spinner.pratica = false;
          }
        });
    };

    /**
	 * @ngdoc method
	 * @name salvaIbanAddebito
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaConto
	 * @description Esegue il salvataggio dell'iban per la pratica
	 */
    this.salvaIbanAddebito = function() {
      if (!self.ibanAddebito) {
        return;
      }
      if (self.ibanAddebito && self.ibanAddebito.trim() === '') {
        return;
      }
      
      self.subSpinner.conto = true;

      $q
        .all({
          salvataggioiban: self.dettPraticaSrvc.promiseSalvataggioIban(
            self.ibanAddebito
          )
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.salvataggioiban)) {
              self.esitoSalvataggio = false;
              return;
            }
            
            self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio =
              response.salvataggioiban.data.result;
            
            self.dettPraticaSrvc.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio;
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.salvataggioiban);
            self.esitoSalvataggio = false;
          }
        )
        .finally(function() {
          self.subSpinner.conto = false;
        });
    };
    
    // Se ho disponibile il conto di addebito, lo mostro in visualizzazione
    if (self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio && self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio.ibanEsterno) {
      self.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio.ibanEsterno;
      self.dettPraticaSrvc.ibanAddebito = self.dettPraticaSrvc.datiPratica.fidoNonOperativo.contoAppoggio;
    }
  };

  CreasSceltaContoCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasSceltaConto/creasSceltaConto.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasSceltaContoComponent = {
    bindings: {},
    controller: CreasSceltaContoCtrl,
    controllerAs: 'creasSceltaContoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasSceltaConto', CreasSceltaContoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasSceltaConto/creasSceltaConto.cmpt.js
// module id = 24
// module chunks = 0 1